import { logger } from '@adornis/base/logging';
import { Arg, Entity, Field, Subscription } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { getCollection } from '@adornis/baseql/server/collections';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration';
import { DateTime } from 'luxon';
import { from, fromEvent } from 'rxjs';
import { startWith, switchMap, tap } from 'rxjs/operators';

@Entity()
export class EventLog extends MongoEntity {
  static _class = 'EventLog';
  static _collectionName = 'eventlog';
  static get allFields() {
    return selectionSet(() => EventLog, 1);
  }

  @Field(type => DateTime) public time!: DateTime;
  @Field(type => String) public event!:
    | 'update'
    | 'route'
    | 'feedback'
    | 'toggleHigherGoals'
    | 'feedbackCancel'
    | 'visibility'
    | null;
  @Field(type => String) public info!: string;
  @Field(type => Boolean) public updating?: boolean;

  @Subscription(type => Date)
  public static lastUpdate(@Arg('courseId', type => String) courseId: string) {
    return (gqlFields: string) => {
      // Use the watchQuery as a dummy notification stream: Run the aggregation of interest manually every time that the watchQuery fires!
      // logger.debug({}, '---------------------------- Subscription initialized from client');
      // The below uses Baseql's watchQuery, but that doesn't listen to insert events. Alternative that does work uses native collection.watch() directly
      // const collHandle = from(getCollectionHandle<EventLog>(EventLog._collectionName));
      // const watchQueryObservable = collHandle.pipe(map(x => x.watchQuery({ event: 'update' })));
      // const res = watchQueryObservable.pipe(
      //   switchMap(async x => {
      //     const coll = await getCollection<EventLog>(EventLog._collectionName);
      //     const res = await coll.find({ event: 'update' }).sort({ time: -1 }).limit(1).toArray();
      //     return res[0] ? res[0].time : DateTime.now();
      //   }),
      //   tap(x => logger.debug(x, '######################################################### WATCH EVENT')),
      // );
      // res.subscribe();
      const coll = from(getCollection<EventLog>(EventLog._collectionName));
      return coll.pipe(
        switchMap(c => fromEvent(c.watch([]), 'change')),
        startWith(0), // StartWith so that everything past this point runs once when the observable is subscribed.
        switchMap(async x => {
          const coll = await getCollection<EventLog>(EventLog._collectionName);
          const res = await coll.find({ event: 'update', info: courseId }).sort({ time: -1 }).limit(1).toArray();
          logger.debug({ result: res[0], course: courseId }, 'LAST UPDATE EVENT');
          return res[0] ? res[0].time : null;
        }),
        tap(x => logger.debug(x, '++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ WATCH EVENT')),
      );
    };
  }
  @Subscription(type => String)
  public static updating() {
    return (gqlFields: string) => {
      const coll = from(getCollection<EventLog>(EventLog._collectionName));
      return coll.pipe(
        switchMap(c => fromEvent(c.watch([]), 'change')),
        startWith(0), // StartWith so that everything past this point runs once when the observable is subscribed.
        switchMap(async x => {
          const coll = await getCollection<EventLog>(EventLog._collectionName);
          const res = await coll.find({ event: 'update' }).sort({ time: -1 }).limit(1).toArray();
          if (!res[0]) return 'null';
          if (res[0].updating === false) return 'undefined';
          logger.debug({ result: res[0] }, 'UPDATING EVENT');
          return res[0].info;
        }),
        // map(v => concat(timer(1000), of(v))),

        // tap(x => logger.debug(x, '++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ WATCH EVENT')),
      );
    };
  }
}
